// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_action_locked = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `This action is locked until you complete ${i.count} additional actions`
};

const de_widget_action_locked = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `Diese Aktion ist gesperrt, bis du ${i.count} weitere Aktionen abschließt`
};

const es_widget_action_locked = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `Esta acción está bloqueada hasta que completes ${i.count} acciones adicionales`
};

const fr_widget_action_locked = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `Cette action est verrouillée jusqu'à ce que vous en complétiez ${i.count} autres`
};

const fi_widget_action_locked = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `Tämä toiminto on lukittu, kunnes suoritat ${i.count} lisätoimintoa`
};

const hi_widget_action_locked = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `यह कार्य तब तक बंद है जब तक आप ${i.count} अतिरिक्त कार्य पूरे नहीं करते`
};

const ja_widget_action_locked = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `この操作は、さらに${i.count}個のアクションを完了するまでロックされています`
};

const nl_widget_action_locked = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `Deze actie is vergrendeld totdat je ${i.count} extra acties voltooit`
};

const pt_widget_action_locked = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `Esta ação está bloqueada até completar ${i.count} ações adicionais`
};

const ro_widget_action_locked = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `Această acțiune este blocată până când finalizezi ${i.count} acțiuni suplimentare`
};

const th_widget_action_locked = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `การดำเนินการนี้ถูกล็อคจนกว่าคุณจะดำเนินการเพิ่มเติมอีก ${i.count} รายการ`
};

const ur_widget_action_locked = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `یہ ایکشن ${i.count} مزید ایکشنز مکمل کرنے تک لاک ہے`
};

const zh_hant1_widget_action_locked = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `此操作已鎖定，直到您完成 ${i.count} 個額外操作`
};

const da_widget_action_locked = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `Denne handling er låst, indtil du gennemfører ${i.count} yderligere handlinger`
};

const it_widget_action_locked = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `Questa azione è bloccata fino a quando non completati ${i.count} azioni aggiuntive`
};

const vn_widget_action_locked = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `Hành động này bị khóa cho đến khi bạn hoàn thành thêm ${i.count} hành động`
};

const ko_widget_action_locked = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `이 액션은 ${i.count}개의 추가 액션을 완료할 때까지 잠겨 있습니다`
};

const tr_widget_action_locked = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `Bu eylem ${i.count} ek eylem tamamlayana kadar kilitli`
};

const lv_widget_action_locked = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `Šī darbība ir bloķēta, līdz pabeidzat ${i.count} papildu darbības`
};

const ar_widget_action_locked = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `هذا الإجراء مقفل حتى تكمل ${i.count} إجراءات إضافية`
};

const bs_widget_action_locked = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `Ova akcija je zaključana dok ne završite ${i.count} dodatnih akcija`
};

const sl_widget_action_locked = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `Ta akcija je zaklenjena, dokler ne dokončate ${i.count} dodatnih akcij`
};

const id_widget_action_locked = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `Aksi ini terkunci sampai Anda menyelesaikan ${i.count} aksi tambahan`
};

const sv_widget_action_locked = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `Denna åtgärd är låst tills du slutför ${i.count} ytterligare åtgärder`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ count: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "hi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" | "sl" | "id" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_action_locked = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_action_locked(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_action_locked", locale)
	if (locale === "en") return en_widget_action_locked(inputs)
	if (locale === "de") return de_widget_action_locked(inputs)
	if (locale === "es") return es_widget_action_locked(inputs)
	if (locale === "fr") return fr_widget_action_locked(inputs)
	if (locale === "fi") return fi_widget_action_locked(inputs)
	if (locale === "hi") return hi_widget_action_locked(inputs)
	if (locale === "ja") return ja_widget_action_locked(inputs)
	if (locale === "nl") return nl_widget_action_locked(inputs)
	if (locale === "pt") return pt_widget_action_locked(inputs)
	if (locale === "ro") return ro_widget_action_locked(inputs)
	if (locale === "th") return th_widget_action_locked(inputs)
	if (locale === "ur") return ur_widget_action_locked(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_action_locked(inputs)
	if (locale === "da") return da_widget_action_locked(inputs)
	if (locale === "it") return it_widget_action_locked(inputs)
	if (locale === "vn") return vn_widget_action_locked(inputs)
	if (locale === "ko") return ko_widget_action_locked(inputs)
	if (locale === "tr") return tr_widget_action_locked(inputs)
	if (locale === "lv") return lv_widget_action_locked(inputs)
	if (locale === "ar") return ar_widget_action_locked(inputs)
	if (locale === "bs") return bs_widget_action_locked(inputs)
	if (locale === "sl") return sl_widget_action_locked(inputs)
	if (locale === "id") return id_widget_action_locked(inputs)
	if (locale === "sv") return sv_widget_action_locked(inputs)
	return "widget_action_locked"
};